import { FormInput } from '../../../../../../../components/form';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { BankAccountModel } from '../../constants';

const IBANModelFields = () => {
    const { t } = useTranslation();

    return (
        <>
            <FormInput
                name="iban"
                label={t('sauron.financeModule.bankAccounts.drawer.fields.iban.label')}
                placeholder={t('sauron.financeModule.bankAccounts.drawer.fields.iban.placeholder')}
                required
            />
            <FormInput
                name="bic"
                label={t('sauron.financeModule.bankAccounts.drawer.fields.bic.label')}
                placeholder={t('sauron.financeModule.bankAccounts.drawer.fields.bic.placeholder')}
                required
            />
        </>
    );
};

const CLABEModelFields = () => {
    const { t } = useTranslation();

    return (
        <>
            <FormInput
                name="clabe"
                label={t('sauron.financeModule.bankAccounts.drawer.fields.clabe.label')}
                placeholder={t('sauron.financeModule.bankAccounts.drawer.fields.clabe.placeholder')}
                required
            />
            <FormInput
                name="bankName"
                label={t('sauron.financeModule.bankAccounts.drawer.fields.bankName.label')}
                placeholder={t('sauron.financeModule.bankAccounts.drawer.fields.bankName.placeholder')}
                required
            />
        </>
    );
};

const RBCModelFields = () => {
    const { t } = useTranslation();

    return (
        <>
            <FormInput
                name="transitNumber"
                label={t('sauron.financeModule.bankAccounts.drawer.fields.transitNumber.label')}
                placeholder={t('sauron.financeModule.bankAccounts.drawer.fields.transitNumber.placeholder')}
                required
            />
            <FormInput
                name="institutionNumber"
                label={t('sauron.financeModule.bankAccounts.drawer.fields.institutionNumber.label')}
                placeholder={t('sauron.financeModule.bankAccounts.drawer.fields.institutionNumber.placeholder')}
                required
            />
            <FormInput
                name="accountNumber"
                label={t('sauron.financeModule.bankAccounts.drawer.fields.accountNumber.label')}
                placeholder={t('sauron.financeModule.bankAccounts.drawer.fields.accountNumber.placeholder')}
                required
            />
        </>
    );
};

export const BankAccountModelFields = ({ model }) => {
    if (!model) {
        return null;
    }

    switch (model) {
        case BankAccountModel.IBAN:
            return <IBANModelFields />;
        case BankAccountModel.CLABE:
            return <CLABEModelFields />;
        case BankAccountModel.RBC:
            return <RBCModelFields />;
        default:
            return null;
    }
};

BankAccountModelFields.propTypes = {
    model: PropTypes.string
};
